import { makeStyles } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

import EColourPanel from '../../../interfaces/EColourPanel';

import DynamicForm from '../../../yoello-lib/modules/dynamicForms/DynamicForms';
import NewUserForm from './NewUser.form';
import useUserMerchantForm from './useUserMerchantForm';

import Loader from './Loader';

const useStyles = makeStyles({
    root: {
        border: '1px solid #E8EAF4',
        boxSizing: 'border-box',
        borderRadius: '16px',
        padding: '1.25rem',
        position: "relative"
    },
    header: {
        fontSize: "2rem"
    },
    description: {
        fontStyle: "italic"
    },
    button: {
        float: "right"
    }
})

const UserMerchantForm = () => {
    const classes = useStyles();    
    const { onSubmit, isLoading } = useUserMerchantForm();

    const { t } = useTranslation();

    return (
        <div className={classes.root}>
            <h1 className={classes.header}>{t("signup.merchantCreate.welcome")}</h1>
            {
                isLoading ? 
                <Loader /> :
                <div>
                    <p className={classes.description}>{t("signup.merchantCreate.description")}</p>
                    <DynamicForm
                        onHandleSubmit={onSubmit}
                        formRows={NewUserForm()}
                        formKeyName="confirm-email"
                        useFormOptions={{
                            reValidateMode: "onChange",
                        }}
                        formButtons={{
                            rightButton: {
                                type: 'submit', label: "signup.newVenue.getStartedButton", endIcon: <ChevronRight />,
                                color: EColourPanel.PRIMARY, className: classes.button
                            }
                        }}
                    />
                </div>
                
            }
            
        </div>
    )
}

export default UserMerchantForm;